import React, { Component } from 'react';

import { translate } from 'components/translate';
import { inject, observer } from 'mobx-react';
import { CommunityService } from 'modules/community';
import CommentListService from 'modules/community/commentList/CommentListService';
import CommentDetailHeader from 'modules/community/history/CommentDetailHeader';
import CommentTopic from 'modules/community/history/CommentTopic';
import CommunityHistoryService from 'modules/community/history/CommunityHistoryService';
import { UiService } from 'modules/ui';
import PropTypes from 'prop-types';

@translate()
@inject((stores) => ({
  hash: stores.UserStore.hash
}))
@observer
export default class CommentDetail extends Component {
  static propTypes = {
    hash: PropTypes.string,
    t: PropTypes.func,
    topicComments: PropTypes.arrayOf(
      PropTypes.shape({
        commentClass: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string
        }),
        commentDate: PropTypes.string,
        content: PropTypes.string,
        id: PropTypes.string,
        lastAction: PropTypes.string,
        page: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          module: PropTypes.string
        }),
        status: PropTypes.string,
        type: PropTypes.string,
        user: PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
          email: PropTypes.string
        })
      })
    ),
    getTopicComments: PropTypes.func
  };

  static defaultProps = {
    topicComments: []
  };

  constructor(props) {
    super(props);

    this.renderCommentDetail = this.renderCommentDetail.bind(this);
    this.commentAnswerReply = this.commentAnswerReply.bind(this);
    this.commentStatusUpdate = this.commentStatusUpdate.bind(this);
  }

  async commentStatusUpdate(item, status) {
    const { getTopicComments } = this.props;

    await CommentListService.commentStatusUpdate(item, status);

    await getTopicComments();
  }

  async commentAnswerReply(item, content) {
    const { getTopicComments, hash: userId } = this.props;

    const commentId = item.id;
    const commentUserId = item && item.user && item.user.id;

    const response = await CommunityService.commentAnswerReply(
      userId,
      commentUserId,
      commentId,
      content
    );

    if (response) {
      await getTopicComments();

      UiService.setAlertSuccess('community.send_notification_message_success');
    }
  }

  renderCommentDetail = (item) => {
    const { getTopicComments } = this.props;
    const isTopic = true;

    return (
      <div className={CommunityHistoryService.classCommentDetail(isTopic)}>
        <CommentDetailHeader item={item} />

        <div
          className={CommunityHistoryService.classCommentDetailContent(isTopic)}
        >
          <div
            className={CommunityHistoryService.classCommentDetailInline(
              isTopic
            )}
          >
            <CommentTopic
              item={item}
              getTopicComments={getTopicComments}
              commentStatusUpdate={this.commentStatusUpdate}
              commentAnswerReply={this.commentAnswerReply}
            />
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { topicComments } = this.props;

    if (!topicComments.length) {
      return <div />;
    }

    return topicComments.map(this.renderCommentDetail);
  }
}
